import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import resourceNames from "../../../common/data/resourceNames";

interface Props {}

export const VehicleDataInput = (props: Props) => {
  return (
    <>
      <div className="two-inputs-container">
        <ReferenceInput
          {...props}
          label="Vehicle"
          source="vehicleId"
          reference={resourceNames.ADMIN_VEHICLES_VIEW}
        >
          <AutocompleteInput resettable />
        </ReferenceInput>
        <TextInput
          {...props}
          source="trailerNumbers"
          label="Attached trailer(s)"
        />
        <TextInput
          {...props}
          source="shippingDocumentNumber"
          label="Shipping doc number(s)"
        />
      </div>
      <div className="two-inputs-container">
        <NumberInput
          {...props}
          source="totalVehicleMiles"
          label="Total vehicle mileage"
        />
        <NumberInput
          {...props}
          source="totalEngineHours"
          label="Total engine hours"
        />
      </div>
      <div className="two-inputs-container">
        <NumberInput
          {...props}
          source="accumulatedVehicleMiles"
          label="Accumulated vehicle miles"
        />
        <NumberInput
          {...props}
          source="elapsedEngineHours"
          label="Elapsed engine hours"
        />
      </div>
    </>
  );
};
